import { render, staticRenderFns } from "./albumsIndex.vue?vue&type=template&id=52f93cd8&scoped=true"
import script from "./albumsIndex.vue?vue&type=script&lang=js"
export * from "./albumsIndex.vue?vue&type=script&lang=js"
import style0 from "./albumsIndex.vue?vue&type=style&index=0&id=52f93cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f93cd8",
  null
  
)

export default component.exports